<template>
    <router-link :to="route" :class="{ 'is-active': isActive }" @click="closeMenu">
        {{ item.title }}
    </router-link>
</template>

<script>
import has from 'lodash/has.js';

export default {
    name: 'NestedEnrollments',

    props: {
        closeMenu: {
            type: Function,
            default: () => {},
        },

        item: {
            required: true,
            type: Object,
        },
    },

    computed: {
        isActive() {
            return this.$route.name === 'course-enrollments-view' || this.$route.name === 'course-import';
        },

        route() {
            if (!has(this.item, 'course_id')) {
                throw new Error(
                    `Course id must be present on the item that is passed to <course>. Received: ${JSON.stringify(
                        this.item
                    )}`
                );
            }

            return {
                name: 'course-enrollments-view',
                params: {
                    courseId: this.item.course_id,
                },
            };
        },
    },
};
</script>
